import React, { useState, useEffect, useRef } from 'react'
import Navber from '../Components/Navber.jsx'
import '../Styles/Group_tour.css'
import '../Styles/Package_tour.css'
import Common_tour_card from '../Components/Common_tour_card.jsx'
import Typemsg from '../Components/Typemsg.jsx'
import User_Destinations from '../Components/User_Destinations.jsx'
import api from '../Api.js'
import { Typography } from '@mui/material'
import CircularProgress from "@mui/material/CircularProgress"
import Box from "@mui/material/Box"
import TourCardSkeleton from "../Components/Helping Component/TourCardSkeleton.jsx"
import TourFilters from "../Components/TourFilters.jsx"

// ✅ Helper to safely get the ID regardless of API structure
const getItemId = (item) => {
  return item?.id || item?.tour?.id || item?.tour?._id || item?._id;
};

const sortTours = (data, option) => {
  const sortedData = [...data];
  switch (option) {
    case "price_low_high":
      return sortedData.sort((a, b) => (a.tour?.pricing?.per_person?.adult || 0) - (b.tour?.pricing?.per_person?.adult || 0));
    case "price_high_low":
      return sortedData.sort((a, b) => (b.tour?.pricing?.per_person?.adult || 0) - (a.tour?.pricing?.per_person?.adult || 0));
    case "duration":
      return sortedData.sort((a, b) => (a.tour?.no_of_days || 0) - (b.tour?.no_of_days || 0));
    case "rating":
      return sortedData.sort((a, b) => (b.rating || 0) - (a.rating || 0));
    default:
      return sortedData;
  }
};

function Group_tour() {
  const [sortOption, setSortOption] = useState("popularity")
  const [searchText, setSearchText] = useState("")
  const [isLoading, setIsLoading] = useState(true) 
  const [isFetchingMore, setIsFetchingMore] = useState(false) 
  const [filteredItems, setFilteredItems] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [searchResult, setSearchResult] = useState("Search Results...")
  const [mobilePanel, setMobilePanel] = useState(null)
  
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  
  // ✅ CHANGED LIMIT TO 3 HERE
  const LIMIT = 6; 

  const observerTarget = useRef(null);
  const isFetchingRef = useRef(false); 

  const fetchGroupData = async (currentPage, isInitial = false) => {
    if (isFetchingRef.current) return; 
    isFetchingRef.current = true;

    if (isInitial) setIsLoading(true);
    else setIsFetchingMore(true);

    try {
      const res = await api.get(`/tours/details?trip_type_id=5&page=${currentPage}&limit=${LIMIT}`);
      
      // Debugging log to check your API response structure
      console.log(`API Response for page ${currentPage}:`, res?.data);

      if (res?.data?.success === true) {
        const newData = Array.isArray(res?.data?.data) ? res.data.data : [];

        // If we received fewer items than the limit, we've reached the end
        if (newData.length < LIMIT) {
          setHasMore(false);
        }

        if (isInitial) {
          setPackageData(newData);
        } else {
          setPackageData((prev) => {
            const existingIds = new Set(prev.map(getItemId));
            const uniqueNewData = newData.filter((item) => !existingIds.has(getItemId(item)));
            return [...prev, ...uniqueNewData];
          });
        }
      } else {
        console.warn("API returned success: false or missing success flag", res?.data);
        // If the API doesn't use a 'success' boolean, you might need to check for res.data.data directly
      }
    } catch (error) {
      console.error("Unable to fetch group tours:", error);
    } finally {
      isFetchingRef.current = false; 
      setIsLoading(false);
      setIsFetchingMore(false);
    }
  };

  useEffect(() => {
    fetchGroupData(1, true);
  }, []);

  useEffect(() => {
    if (page > 1) {
      fetchGroupData(page, false);
    }
  }, [page]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !isFetchingRef.current && !isLoading) {
          setPage((prevPage) => prevPage + 1);
        }
      },
      { threshold: 0.1 } 
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => {
      if (observerTarget.current) observer.unobserve(observerTarget.current);
    };
  }, [hasMore, isLoading]);

  const handleSortChange = (event) => {
    setSortOption(event.target.value)
    setMobilePanel(null)
  };

  const handleSearch = (event) => {
    event?.preventDefault();
  }

  useEffect(() => {
    const query = searchText.trim().toLowerCase();
    let data = packageData.filter((item) => {
      if (!query) return true;
      const destinationName = item.tour?.destination?.name?.toLowerCase() || "";
      const destinationSlug = item.tour?.destination?.slug?.toLowerCase() || "";
      return (
        item.tour?.description?.toLowerCase().includes(query) ||
        item.tour?.title?.toLowerCase().includes(query) ||
        destinationName.includes(query) ||
        destinationSlug.includes(query)
      );
    });

    data = sortTours(data, sortOption);
    setFilteredItems(data);

    setSearchResult(
      query && data.length === 0
        ? "No Search Result"
        : query
          ? `Found ${data.length} result(s)`
          : ""
    );
  }, [searchText, packageData, sortOption])

  const sortOptions = [
    { key: "popularity", label: "Popularity" },
    { key: "price_low_high", label: "Price: Low → High" },
    { key: "price_high_low", label: "Price: High → Low" },
    { key: "duration", label: "Duration (Days)" },
    { key: "rating", label: "Rating" },
  ];

  return (
    <div style={{ minHeight: "100vh" }}>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      <div className='group_container' style={{ background: `url(${require("../Images/grouptour1.jpg")}) center/cover no-repeat` }}>
        <h1 style={{ color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)', padding: '10px 20px', borderRadius: '8px', display: 'inline-block', backdropFilter: 'blur(4px)' }}>
          Group Tour
        </h1>
      </div>

      <div className="tourPageLayout">
        <TourFilters
          mobilePanel={mobilePanel}
          setMobilePanel={setMobilePanel}
          searchText={searchText}
          setSearchText={setSearchText}
          handleSearch={handleSearch}
          searchResult={searchResult}
          sortOption={sortOption}
          handleSortChange={handleSortChange}
          sortOptions={sortOptions}
        />

        <div className="cardsSection">
          {isLoading ? (
            <div className="tourCardsGrid">
              {/* Changed initial skeleton to match LIMIT */}
              {Array.from(new Array(LIMIT)).map((_, index) => (
                <TourCardSkeleton key={index} />
              ))}
            </div>
          ) : (
            <>
              {filteredItems.length === 0 ? (
                <div style={{ textAlign: "center", padding: "50px", width: "100%" }}>
                  <h3>No tours found matching your criteria.</h3>
                </div>
              ) : (
                <div className="tourCardsGrid">
                  {filteredItems.map((item) => (
                    <Common_tour_card key={getItemId(item)} packagedata={item} />
                  ))}
                </div>
              )}

              {/* 🔄 Loading Skeleton */}
              {isFetchingMore && (
                <div className="tourCardsGrid" style={{ width: "100%", marginTop: "20px" }}>
                  {Array.from(new Array(LIMIT)).map((_, index) => (
                    <TourCardSkeleton key={`fetching-skeleton-${index}`} />
                  ))}
                </div>
              )}

              {/* 🔄 Infinite Scroll Sentinel */}
              {hasMore && !isFetchingMore && (
                <div ref={observerTarget} style={{ height: "20px", width: "100%", marginTop: "20px" }} />
              )}
            </>
          )}
        </div>
      </div>

      <div className="mobileTourControls">
        <button type="button" onClick={() => setMobilePanel("filter")}>☰ Filter</button>
        <button type="button" onClick={() => setMobilePanel("sort")}>⇅ Sort</button>
      </div>

      <User_Destinations />
    </div>
  )
}

export default Group_tour;